// Generated with util/create-component.js
import React from 'react';
import classNames from 'classnames';

import styles from './Grid.module.scss';

type SmallGridColumns = 1 | 2 | 3 | 4;
type LargeGridColumns = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export interface GridProps {
  /** The content of the grid */
  children: React.ReactNode;
  /** Optional CSS class to be applied */
  className?: string;
  /** If true, make this the container of the grid. If false, this is a grid item */
  container?: boolean;
  /** How many grid cells the grid item should occupy for small screens and up.
   * Default is 4 (full width) */
  sm?: SmallGridColumns;
  /** How many grid cells the grid item should occupy for 768px screens and up.
   * If value is null, the value will fallback to the sm value. */
  md?: LargeGridColumns;
  /** How many grid cells the grid item should occupy for 1200px screens and up.
   * If value is null, the value will fallback to the md value. */
  lg?: LargeGridColumns;
  /** Which grid cell should this item start at on small screens and up.
   * Default is next available column. */
  smOffset?: SmallGridColumns;
  /** Which grid cell should this item start at on 768px screens and up.
   * Default is next available column or what was set for smOffset */
  mdOffset?: LargeGridColumns;
  /** Which grid cell should this item start at on 1200px screens and up.
   * Default is next available column or what was set for mdOffset */
  lgOffset?: LargeGridColumns;
}

function Grid({
  children,
  className = '',
  container,
  sm = 4,
  md,
  lg,
  smOffset,
  mdOffset,
  lgOffset,
}: GridProps) {
  const gridItem = !container;
  return (
    <div
      className={classNames(className, {
        [styles.grid]: container,
        [styles.gridItem]: gridItem,
        [styles[`sm-${sm}`]]: sm,
        [styles[`md-${md}`]]: md,
        [styles[`lg-${lg}`]]: lg,
        [styles[`sm-offset-${smOffset}`]]: smOffset,
        [styles[`md-offset-${mdOffset}`]]: mdOffset,
        [styles[`lg-offset-${lgOffset}`]]: lgOffset,
      })}
    >
      {children}
    </div>
  );
}

export default Grid;
